import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const counties = [
  { name: "Passaic County", path: "/service-areas/passaic-county", towns: "Totowa, Wayne, Little Falls & more" },
  { name: "Bergen County", path: "/service-areas/bergen-county", towns: "Ridgewood, Glen Rock, Wyckoff, Franklin Lakes, Saddle River" },
  { name: "Essex County", path: "/service-areas/essex-county", towns: "Montclair, the Caldwells, Essex Fells & more" },
  { name: "Morris County", path: "/service-areas/morris-county", towns: "Kinnelon, Mountain Lakes & more" },
];

export function ServiceAreaSection() {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Serving <span className="text-gradient-gold">North Jersey</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            We're based in Totowa and serve homeowners throughout Passaic, Bergen, Essex, and Morris counties, from Wayne and Montclair to Ridgewood and Kinnelon. See all of our <Link to="/service-areas" className="text-secondary underline underline-offset-4 hover:text-secondary/80 font-medium">masonry service areas across North Jersey</Link>.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {counties.map((county) => (
            <Link
              key={county.path}
              to={county.path}
              className="bg-card rounded-xl p-6 border border-border hover:border-secondary/30 transition-all duration-300 text-center group"
            >
              <div className="w-12 h-12 rounded-full bg-gradient-gold flex items-center justify-center mx-auto mb-4">
                <MapPin className="h-6 w-6 text-secondary-foreground" />
              </div>
              <h3 className="text-lg font-bold mb-1 group-hover:text-secondary transition-colors">
                {county.name}
              </h3>
              <p className="text-sm text-muted-foreground">{county.towns}</p>
            </Link>
          ))}
        </div>

        <div className="flex justify-center">
          <Link
            to="/service-areas"
            className="inline-flex items-center gap-2 text-secondary hover:text-secondary/80 font-semibold transition-colors"
          >
            See All Service Areas <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
